import React, { useEffect, useState } from "react";
import { GROUP_GLOBAL_FEATURES } from "../app/Utils/CONST";
import { handleSpringDataRequest } from "../app/api";

const useGroupAccessControlData = (groupId) => {
  const [groupAccessControlData, setGroupAccessControlData] = useState(null);

  useEffect(() => {
    if (groupId) {
      handleSpringDataRequest(
        `core/api/v1/groupAccesscontrol/get-meta-group-accessmap?groupId=${groupId}`
      ).then((res) => {
        setGroupAccessControlData(res);
      });
    }
  }, [groupId]);

  const isGroupPerformanceDashboardEnabled = groupAccessControlData?.find(
    (data) => data.accessKey === GROUP_GLOBAL_FEATURES.GroupPerformanceDashboard
  )?.enabled;

  return {
    isGroupPerformanceDashboardEnabled,
  };
};

export default useGroupAccessControlData;
